<template>
  <div class="empty-book-section">
    <div class="grid grid--wide">
      <h2 class="xs-12 dea-heading--medium-xxl">I miei libri</h2>
    </div>
    <div class="dea-bg-grey-light empty-book-section__container">
      <div class="grid grid--wide">
        <div v-if="parent || student" class="xs-12">
          <h2 class="dea-heading--regular-xxl">
            <template v-if="student">
              Qui troverai i libri che attiverai!
            </template>
            <template v-else>
              Qui troverai i libri che attiverai per la tua famiglia!
            </template>
          </h2>
          <div class="empty-book-section__activation empty-book-section__activation--family">
            <!-- TODO: Add image or icon when avaiable -->
            <img src="" alt="" />
            <h3 class="dea-heading--medium-xl">
              <template v-if="student">
                Se hai già una copia di un libro tra le mani, attivala subito!
              </template>
              <template v-else>
                Se avete già una copia di un libro, attivala subito!
              </template>
            </h3>
            <Buttons
              class="dea-button--large dea-button--iconRight"
              icon="attiva"
              @click="$emit('open-activation-modal')"
            >
              Attiva Libro
            </Buttons>
            <hr class="small-line--grey empty-book-section__separator" />
            <h3 class="dea-heading--medium-l">Hai bisogno di aiuto? Consulta la nostra Area Assistenza</h3>
            <!-- FIXME: when the route will be ready, change this into a router-link -->
            <Buttons
              type="a"
              class="dea-button--large dea-button--iconRight"
              :href="agentsUrl"
              target="_blank"
              icon="richiedi-info"
            >
              Assistenza
            </Buttons>
          </div>
        </div>
        <div v-else class="xs-12">
          <h2 class="dea-heading--medium-xxl">
            Qui troverai i libri e le demo che attiverai o che la tua agenzia di riferimento attiverà per te!
          </h2>
          <div class="empty-book-section__activation">
            <h3 class="dea-heading--light-xl">Hai in adozione un libro Deascuola?</h3>
            <p>
              <span class="dea-heading--regular-m empty-book-section__text"
                >Se hai già una copia del libro tra le mani, attivala subito!</span
              >
              <Buttons
                class="dea-button--large dea-button--inline dea-button--iconRight"
                icon="attiva"
                @click="$emit('open-activation-modal')"
              >
                Attiva Libro
              </Buttons>
            </p>
            <p>
              <span class="dea-heading--regular-m empty-book-section__text"
                >Se ancora non hai la tua copia o hai bisogno di assistenza puoi chiedere aiuto alla tua agenzia di
                riferimento:</span
              >
              <Buttons
                type="a"
                class="dea-button--large dea-button--inline dea-button--iconRight"
                :href="agentsUrl"
                target="_blank"
                icon="richiedi-info"
              >
                Assistenza e agenzia
              </Buttons>
            </p>
          </div>
          <div class="empty-book-section__info">
            <h3 class="ddea-heading--light-xl empty-book-section__text">Non conosci ancora i libri Deascuola?</h3>
            <Links
              :class="['dea-links', 'dea-links--pointer', `dea-links--${linkColor}`]"
              label-class="dea-heading--medium-xs"
              :href="catalogLink"
              icon="go-to"
              target="_blank"
              >Esplora il catalogo</Links
            >
            <p>
              <span class="dea-heading--regular-m empty-book-section__text">Poi valuta una copia digitale:</span>
              <Buttons
                class="dea-button--large dea-button--inline dea-button--iconRight"
                icon="copia-digitale"
                @click="$emit('open-evaluation-modal')"
              >
                Richiedi copia digitale
              </Buttons>
            </p>
            <p>
              <span class="dea-heading--regular-m empty-book-section__text"
                >O contatta la tua agenzia di riferimento per saperne di più o ricevere assistenza:</span
              >
              <Buttons
                type="a"
                class="dea-button--large dea-button--inline dea-button--iconRight"
                :href="agentsUrl"
                target="_blank"
                icon="richiedi-info"
              >
                Assistenza e agenzia
              </Buttons>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Links from "@/components/elements/Links";
import Buttons from "deascuola-storybook/src/components/elements/Buttons";
import UserLinks from "~/components/books/mixins/UserLinks";

export default {
  name: "EmptyBookPage",
  components: { Links, Buttons },
  mixins: [UserLinks],
  props: {
    linkColor: {
      type: String,
      default: "",
    },
    parent: {
      type: Boolean,
      default: false,
    },
    student: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    subjectLink(subject) {
      let target;
      if (this.student) target = "studente";
      else if (this.parent) target = "famiglia";
      else target = "docente";
      return `${this.$root.config.publicURL}/work/materia/${subject.id}/${target}/`;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.myhome-books {
  @include media("<=s") {
    margin: 0;
  }
}

.small-line--grey {
  width: 100%;
}

.empty-book-section {
  &__container {
    margin-top: $space-base;
    padding: $space-large 0;
  }

  &__activation,
  &__info {
    margin-top: $space-x-large;
  }

  &__info {
    .dea-links {
      margin-left: 0 !important; //sass-lint:disable-line no-important
    }
  }

  &__activation--family {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  &__text,
  &__buttons {
    @include media("<=xs") {
      display: block;
    }
  }

  &__buttons {
    @include media("<=xs") {
      margin-top: $space-small;
      text-align: center;
    }
  }

  &__separator {
    margin-top: $space-large;
  }

  .dea-button,
  .dea-links {
    @include media("<=xs") {
      margin: auto;
    }
    margin-left: $space-small;
  }
}
</style>
